import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import * as yup from "yup";
import {
  CheckboxField,
  SubmitButton,
  TextField,
  StatusField,
  Form,
  withDesign,
  withAuth
} from "../../common";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import LoginFormDesigner from "./LoginFormDesigner";

const styles = theme => ({
  form: {
    //width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(1)
  }
});

const validationSchema = yup.object().shape({
  username: yup.string().required("Required"),
  password: yup.string().required("Required")
});

const LoginForm = ({
  classes,
  initValues = {
    username: "",
    password: "",
    remember: false
  },
  initStatus,
  isInitialValid,
  refreshAuth
}) => {
  function onSubmit(vals, actions) {
    actions.setStatus(undefined);
    refreshAuth(vals, () => actions.setSubmitting(false));
  }

  const autoFocusUsername = Boolean(initValues && !initValues.username);

  return (
    <Form
      isInitialValid={isInitialValid}
      initialValues={initValues}
      validationSchema={validationSchema}
      className={classes.form}
      onSubmit={onSubmit}
      initialStatus={initStatus}
    >
      <Box m={1}>
        <StatusField name="status" />
      </Box>
      <Box m={1}>
        <TextField
          fullWidth
          required
          label="Email Address"
          name="username"
          autoComplete="username"
          autoFocus={autoFocusUsername}
        />
      </Box>
      <Box m={1}>
        <TextField
          fullWidth
          required
          label="Password"
          name="password"
          autoComplete="current-password"
          type="password"
          autoFocus={!autoFocusUsername}
        />
      </Box>
      <Box m={1}>
        <CheckboxField name="remember" label="Remember me" color="secondary" />
      </Box>
      <Box m={1} display="flex" alignItems="baseline">
        <SubmitButton
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          Sign in
        </SubmitButton>
        <Box pl={4}>
          <Typography variant="caption" color="textSecondary">
            <Link to="/password-reset">Reset password</Link>
          </Typography>
        </Box>
      </Box>
    </Form>
  );
};

export default withAuth(
  withStyles(styles, { name: "Login", withTheme: true })(
    withDesign(LoginForm, LoginFormDesigner)
  )
);
